<template>
  <v-container fluid class="AddNewUser-mainContainer"> <!-- uso de clases css class="componente-nombreClase"-->
    <v-row v-bind:class="{'smartbell-justifyAlign': userData.onboarding === false}">
        <v-col md="2" class="smartbell-smartbellLeftSideDesktop">

        </v-col>
        <v-col cols="12" md="10" offset-md="2">
             <v-row class="UserAdministration-centerCowsNumberRow">
                <v-col md="4">

                </v-col>
                <v-col md="4">

                </v-col>
                <v-col md="4" class="GroupForm-cowNumber UserAdministration-centerCowsNumber">
                    <span class="GroupForm-cowNumberLeft">Usuarios en sistema</span><span class="GroupForm-cowNumberRight">{{numberOfAnimals}}</span>
                </v-col>
            </v-row>
            <v-row align="center" justify="center" class="AddUser-footer">
                <v-col cols="10" md="12">
                    <v-row align="center" justify="center" v-if="userData.onboarding === false">
                    <v-col md="10" cols="10" class="UserProfile-title">
                        <h2>Aqui puedes editar la informacion de tu cuenta</h2>
                    </v-col>
                    </v-row>
                    <v-row align="center" justify="center">
                        <v-col md="12" cols="12" class="AddUser-cardRightPadding">
                            <v-card class="AddUser-cardContainer Add-userTip">
                                <v-toolbar dark color="#1460AA" class="DashCow-tooltipTitle">
                                    <v-select
                                        :items="userTypesList"
                                        v-model="userTypeList"
                                    >
                                    </v-select>
                                </v-toolbar>
                                <v-row>
                                    <v-col md="3" class="AddUser-rightCol">
                                        <v-row align="center" justify="center" class="">
                                            <v-col md="12" cols="12">
                                                <img src="../assets/FarmerImage.png" alt="" class="">
                                            </v-col>
                                        </v-row>
                                        <v-row align="center" justify="center" class="">
                                            <v-col md="12" cols="12" class="">
                                                <v-btn text class=" smartbell-blueButton smartbell-buttonCorrection">Agregar Foto<img src="../assets/photoIcon.png" alt="" class=""></v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col md="6">
                                        <v-row>
                                            <h3 class="AddUser-title">Datos Generales</h3>
                                        </v-row>
                                        <v-row>
                                            <v-col md="6" class="AddUser-noPadding">
                                                <v-col md="12" cols="12">
                                                    <v-text-field
                                                    v-model="newUser.name"
                                                    clearable
                                                    class="form-text-input"
                                                    label="Teléfono"
                                                    outlined
                                                    placeholder="+52-347-101-5721"
                                                    required>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col md="12" cols="12">
                                                    <v-text-field
                                                    v-model="newUser.name"
                                                    clearable
                                                    class="form-text-input"
                                                    label="Teléfono"
                                                    outlined
                                                    placeholder="+52-347-101-5721"
                                                    required>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col md="12" cols="12" class="AddUser-noPaddingUpDown">
                                                    <v-text-field
                                                    v-model="newUser.name"
                                                    clearable
                                                    class="form-text-input"
                                                    label="Teléfono"
                                                    outlined
                                                    placeholder="+52-347-101-5721"
                                                    required>
                                                    </v-text-field>
                                                </v-col>
                                            </v-col>
                                            <v-col md="6" class="AddUser-noPadding">
                                                <v-col md="12" cols="12">
                                                    <v-text-field
                                                    v-model="newUser.name"
                                                    clearable
                                                    class="form-text-input"
                                                    label="Teléfono"
                                                    outlined
                                                    placeholder="+52-347-101-5721"
                                                    required>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col md="12" cols="12">
                                                    <v-text-field
                                                    v-model="newUser.name"
                                                    clearable
                                                    class="form-text-input"
                                                    label="Teléfono"
                                                    outlined
                                                    placeholder="+52-347-101-5721"
                                                    required>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col md="12" cols="12" class="AddUser-noPaddingUpDown">
                                                    <v-text-field
                                                    v-model="newUser.name"
                                                    clearable
                                                    class="form-text-input"
                                                    label="Teléfono"
                                                    outlined
                                                    placeholder="+52-347-101-5721"
                                                    required>
                                                    </v-text-field>
                                                </v-col>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col md="3" class="UseProfile-leftCol">
                                        <v-row>
                                            <h3 class="AddUser-title">Canales de alertas</h3>
                                        </v-row>
                                        <v-row class="UserProfile-alertsContainer">
                                            <v-col md="12">
                                                <div class="AddUser-singleAlert" v-bind:class="{ 'UserProfile-imageContainerActive': mailActive }">
                                                <div class="UserProfile-sigleAlertLeft">
                                                    <img src="../assets/EmailSmall.svg" alt=""> <span>Email</span>
                                                </div>
                                                <div class="UserProfile-sigleAlertRight">
                                                    <input type="checkbox" name="" v-model="mailActive">
                                                </div>
                                                </div>
                                            </v-col>
                                            <v-col md="12">
                                                <div class="AddUser-singleAlert" v-bind:class="{ 'UserProfile-imageContainerActive': notificationActive}">
                                                <div class="UserProfile-sigleAlertLeft">
                                                    <img src="../assets/MobileAlertSmall.svg" alt=""> <span>Notificaciones</span>
                                                </div>
                                                <div class="UserProfile-sigleAlertRight">
                                                    <input type="checkbox" name="" v-model="notificationActive">
                                                </div>
                                                </div>
                                            </v-col>
                                            <v-col md="12">
                                                <div class="AddUser-singleAlert" v-bind:class="{ 'UserProfile-imageContainerActive': webActive }">
                                                <div class="UserProfile-sigleAlertLeft">
                                                    <img src="../assets/WebAlertSmall.svg" alt=""> <span>Alerta Web</span>
                                                </div>
                                                <div class="UserProfile-sigleAlertRight">
                                                    <input type="checkbox" name="" v-model="webActive">
                                                </div>
                                                </div>
                                            </v-col>
                                            <v-col md="12">
                                                <div class="AddUser-singleAlert" v-bind:class="{ 'UserProfile-imageContainerActive': smsActive }">
                                                <div class="UserProfile-sigleAlertLeft">
                                                    <img src="../assets/SMSSmall.svg" alt=""> <span>SMS</span>
                                                </div>
                                                <div class="UserProfile-sigleAlertRight">
                                                    <input type="checkbox" name="" v-model="smsActive">
                                                </div>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row justify="center" >
                                    <v-col md="12" class="AddUser-addButton">
                                        <v-btn class="smartbell-greenButton smartbell-buttonCorrection">
                                            Crear Usuario
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-footer color="#F9FDFE" padless class="smartbell-footer">
            <v-row justify="center" no-gutters>
                <v-col md="10" v-bind:class="{ 'smartbell-offSet2': userData.onboarding}">
                <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Preguntas frecuentes</v-btn>
                <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Ayuda</v-btn>
                <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Precios</v-btn>
                <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Calcula tu eficiencia</v-btn>
                <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Aviso de privacidad</v-btn>
                <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Terminos y condiciones</v-btn>
                </v-col>
            </v-row>
            </v-footer>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import NavBar from '@/views/NavBar.vue'
export default {
  name: 'AddNewUser',
    data () {
      return {
        smsActive:false,
        webActive:false,
        mailActive:true,
        notificationActive:false,
        newUser:{
            name:'',
            lastName:'',
            email:'',
            phone:'',
            password:''
        },
        userTypesList: ['Administrador','Veterinario'],
        userTypeList: 'Administrador'
      }
  },
  components: {
      NavBar
  },
  computed: {
    animals() {
      return this.$store.getters.getAnimals;
    },
    userData(){
        return this.$store.getters.getUserData
    },
    numberOfAnimals() {
        if(this.$store.getters.getAnimals.length < 10){
            return "00"+this.$store.getters.getAnimals.length;
        } else if(this.$store.getters.getAnimals.length < 100){
            return "0"+this.$store.getters.getAnimals.length;
        } else if(this.$store.getters.getAnimals.length >= 100){
            return this.$store.getters.getAnimals.length;
        }
        return 0
    },
  },
  methods: {
  },
  mounted () {
  }
};
</script>

<style lang="css">
  @import '../style/AddNewUser.css';
</style>
